import { useState, useEffect } from 'react';

const Footer = () => {
  const [ipAddress, setIpAddress] = useState('');

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => setIpAddress(data.ip))
      .catch(() => setIpAddress('Not available'));
  }, []);

  return (
    <footer className="bg-gray-100 py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4">
        {/* Desktop view */}
        <div className="hidden sm:flex justify-between items-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Lernvent Event Management. All rights reserved.
          </p>
          <p className="text-sm text-gray-600">
            IP Address: {ipAddress || 'Loading...'}
          </p>
        </div>

        {/* Mobile view */}
        <div className="sm:hidden space-y-2">
          <div className="flex flex-col items-center space-y-2 text-center">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} Lernvent Event Management
            </p>
            <p className="text-xs text-gray-500">
              All rights reserved
            </p>
            <div className="text-xs text-gray-500 bg-gray-200 px-3 py-1 rounded-full">
              IP: {ipAddress || 'Loading...'}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;